/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanCopiedEducationDto
 */
export interface MonthPlanCopiedEducationDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanCopiedEducationDto
   */
  id: string;
}

export function MonthPlanCopiedEducationDtoFromJSON(json: any): MonthPlanCopiedEducationDto {
  return MonthPlanCopiedEducationDtoFromJSONTyped(json, false);
}

export function MonthPlanCopiedEducationDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanCopiedEducationDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
  };
}

export function MonthPlanCopiedEducationDtoToJSON(value?: MonthPlanCopiedEducationDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
  };
}
